import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aaa576e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-location-switcher" }
const _hoisted_2 = { class: "contact-location-switcher__title" }
const _hoisted_3 = { class: "contact-location-switcher__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DKButton = _resolveComponent("DKButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('footer.contact.title')), 1),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactFooterNavigationTree, (contactFooterNavigationTreeItem) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "contact-location-switcher__list-item",
          key: contactFooterNavigationTreeItem.id
        }, [
          _createVNode(_component_DKButton, {
            inverted: true,
            onClick: ($event: any) => (_ctx.$emit('clickContactLink', contactFooterNavigationTreeItem))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(contactFooterNavigationTreeItem.label), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]))
      }), 128))
    ])
  ]))
}